<template>
  <div v-if="bannerToDisplay">
    <hp5-spacing-vertical xs="xxs" sm="0"></hp5-spacing-vertical>
    <component :is="bannerToDisplay" v-bind="{ result: result, rank: rank }"/>
    <hp5-spacing-vertical xs="0" sm="sm"></hp5-spacing-vertical>
  </div>
</template>

<script setup>

    /**
     * This component is a general component to display the network banner information
     * inside the search result cards. The logic to determine which card to be
     * displayed is delegated to the useNetworkBanner composable.
     */

    const props = defineProps({
      result: Object,
      rank: Number
    })

    const model = useFCPModel()
    const { getNetworkBannerComponent } = useNetworkBanner(model, props.result)

    //Compute only once when the component is instantiated.  If we use a computed property, the component's banner get rendered after
    //data changes in the application.  We don't want the component to re-render once it has already rendered. 
    const bannerToDisplay = getNetworkBannerComponent()
  
</script>